import React from 'react'
import { useTranslation } from '@disco/i18n/use-translation'

interface SuccessStepProps {
  data: Record<string, unknown>
}

export default function SuccessStep({ data }: SuccessStepProps) {
  const { t } = useTranslation('accounts')
  const email = data.email as string

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          {t('accounts:thanks', 'Thanks!')}
        </h1>
        <p className="text-lg text-gray-600 mb-2">
          {t(
            'accounts:ourTeamIsReviewingYourSignupAndWillBeInTouchVia',
            'Our team is reviewing your signup and will be in touch via',
          )}
        </p>
        <p className="text-lg text-gray-600">{email}.</p>
      </div>
    </div>
  )
}
